module.exports = __webpack_public_path__ + "img/27.f8bb8743.png";